var publicPath = __webpack_public_path__;
                    var symbolUrl = 'sprites.cec557102adab7af026c399acc74bb55.svg#j';
                    var viewUrl = 'sprites.cec557102adab7af026c399acc74bb55.svg#view-j';

                    

                    module.exports = {
                        url: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 62 58',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };